import { identity, map, memoizeWith } from "ramda";

// do not use this: not compatible with IE
export const normalize = memoizeWith(
	identity,
	(str) => !!str && str.normalize("NFKD").replace(/[^\w]/g, "").toLowerCase()
);

export const normalizeAll = memoizeWith(identity, map(normalize));
